import { FiPackage } from "react-icons/fi";
import { BsHouseDoor } from "react-icons/bs";
import { IoBus } from "react-icons/io5";

const DeliveryDetailsTimelineItem = ({ data, delivered, styles, refresh }) => {
  const {
    displayMessage,
    scannedDt,
    status,
    toDepot,
    deliveryDateDt,
    deliveryTime,
  } = data;

  // Format scanLogs from dd/mm/yyyy to "11 Nov 2021"
  let options = { day: "numeric", month: "short", year: "numeric" };

  // Format displayDate
  const dd = new Date(Date.parse(scannedDt));
  const displayDate = dd.toLocaleDateString("en-GB", options);

  // Format deliveryDate
  const da = new Date(Date.parse(deliveryDateDt));
  const formattedDeliveryDate = da.toLocaleDateString("en-GB", options);

  const displayTime = dd.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const convertTime12to24 = (time12h) => {
    const [time, modifier] = time12h.split(" ");

    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  };

  const formattedDeliveryTime = deliveryTime
    ? convertTime12to24(deliveryTime)
    : null;

  return (
    <>
      <div className="timeline-item">
        <div className="timeline-content">
          {/* Disabled until we finalize delivery status */}
          {/* Render dashed line below icon  */}
          {/* { status === 'delivered' && */}
          {/* <div className="before-block"></div> */}
          {/* } */}

          {/* Render solid line below icon if not just picked up or dropped off */}
          {/* { status !== 'delivered' && status !== 'incoming' && status !== 'pickup' && */}
          {/* <div className="after-block"></div> */}
          {/* } */}

          {delivered && status === "van" && (
            <div className="timeline-icon delivered">
              <BsHouseDoor />
            </div>
          )}

          {!delivered && status === "van" && (
            <div className="timeline-icon van">
              <IoBus />
            </div>
          )}

          {status !== "van" && status !== "delivered" && (
            <div className="timeline-icon ready">
              <FiPackage />
            </div>
          )}

          <div className="timeline-content-text">
            <h3 className="subheading" style={styles.textHighlight}>
              {displayMessage &&
                displayMessage === "van" &&
                "Onboard for delivery"}
              {displayMessage &&
                displayMessage === "returnToDepot" &&
                "Re-Sort"}
              {displayMessage &&
                displayMessage !== "returnToDepot" &&
                displayMessage !== "van" &&
                displayMessage}
              {toDepot && <span> ({toDepot.stateAbbr})</span>}
            </h3>
            <div className="timeline-content-date">
              <p>
                {displayDate && displayDate !== "Invalid Date" && displayDate}
                {formattedDeliveryDate &&
                  displayDate === "Invalid Date" &&
                  formattedDeliveryDate}
              </p>
              <p className="text-lowercase">
                {displayTime && displayTime !== "Invalid Date" && displayTime}
                {deliveryTime &&
                  displayTime === "Invalid Date" &&
                  formattedDeliveryTime}
              </p>
            </div>
          </div>
        </div>
        {status === "pending" && (
          <div style={{ marginTop: "-1rem" }}>{refresh}</div>
        )}
      </div>
    </>
  );
};

export default DeliveryDetailsTimelineItem;
